import { useEffect } from "react";
import { useAppData } from "@/contexts/AppDataContext";
import { productApi } from "@/resources/product";

export function useBrandAutoSwitch(productId: string | undefined) {
  const { selectedBrandId, brands, setSelectedBrandId } = useAppData();

  const { data: productBrand, isLoading } = productApi.useGetProductBrand(productId);

  const targetBrandId = productBrand?.brand_id;
  const needsSwitch = targetBrandId != null && targetBrandId !== selectedBrandId;
  const brandsLoaded = brands.length > 0;
  const canSwitch = needsSwitch && brandsLoaded && brands.some((b) => b.id === targetBrandId);

  useEffect(() => {
    if (canSwitch && targetBrandId != null) {
      setSelectedBrandId(targetBrandId);
    }
  }, [canSwitch, targetBrandId, setSelectedBrandId]);

  return {
    isResolvingBrand: isLoading || (needsSwitch && !brandsLoaded) || (needsSwitch && canSwitch),
  };
}
